















import { EstimateTemplate } from "@/api/estimate-templates-api";
import SelectOption from "@/common/ui/presenters/select-option";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class UseEstimateTemplate extends Vue {
  @Prop({ default: false }) disabled!: boolean;
  selected: string = "";

  get options(): SelectOption[] {
    return this.templates.map(estimateTemplateOption);
  }

  get templates(): EstimateTemplate[] {
    return this.$store.state.estimateTemplate.estimateTemplates;
  }

  mounted() {
    this.$store.dispatch("estimateTemplate/load");
  }

  useTemplate(id: string) {
    const template = this.templates.find(t => t.id === id);
    if (!template) {
      throw new Error("template is not found.");
    }
    this.$emit("submit", template);
  }
}

function estimateTemplateOption(item: EstimateTemplate): SelectOption {
  return {
    text: item.title,
    value: item.id
  };
}
